/* IMPORT */
import adjustChannel from './adjust_channel.js';
/* MAIN */
const transparentize = (color, amount) => {
    return adjustChannel(color, 'a', -amount);
};
/* EXPORT */
export default transparentize;
